export const TUTORIAL_VERSION = 1;
const KEY = 'pushio_tutorial';

export interface TutorialPreference {
  tutorialCompleted: boolean;
  tutorialSkipped: boolean;
  tutorialVersion: number;
}

export function loadTutorialPreference(): TutorialPreference {
  try {
    return {
      tutorialCompleted: false,
      tutorialSkipped: false,
      tutorialVersion: 0,
      ...JSON.parse(localStorage.getItem(KEY) || '{}'),
    };
  } catch {
    return { tutorialCompleted: false, tutorialSkipped: false, tutorialVersion: 0 };
  }
}

export function shouldOfferTutorial(): boolean {
  return shouldOfferTutorialPreference(loadTutorialPreference());
}

export function shouldOfferTutorialPreference(preference: TutorialPreference): boolean {
  return preference.tutorialVersion < TUTORIAL_VERSION
    || (!preference.tutorialCompleted && !preference.tutorialSkipped);
}

export function saveTutorialChoice(choice: 'completed' | 'skipped'): void {
  localStorage.setItem(KEY, JSON.stringify({
    tutorialCompleted: choice === 'completed',
    tutorialSkipped: choice === 'skipped',
    tutorialVersion: TUTORIAL_VERSION,
  } satisfies TutorialPreference));
}

export function resetTutorialPreference(): void {
  localStorage.removeItem(KEY);
}
